import { render } from "./FlutterChannelPage.vue?vue&type=template&id=2592ba19&scoped=true"
import script from "./FlutterChannelPage.vue?vue&type=script&lang=js"
export * from "./FlutterChannelPage.vue?vue&type=script&lang=js"

import "./FlutterChannelPage.vue?vue&type=style&index=0&id=2592ba19&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2592ba19"]])

export default __exports__